const product = {
    page_title: "Product list",
    operator_btn1: "Commodity Warehousing",
    operator_btn2: "Add Product",
    operator_btn3: "Warehousing",
    fl_search: "Enter Search",
    fl_category: "Product Category",
    fl_brand: "Product Brand",
    fp_name_num: "Name/Number",
    fp_category: "product category",
    fp_brand: "brand",
    tl_code: "Number",
    tl_image: "Product Image",
    tl_name: "Product Name",
    tl_price_serial: "Price/Product No.",
    tl_tags: "Label",
    tl_quantity: "Inventory",
    tl_sales: "Sales",
    tr_price: "Price",
    tr_serial: "Product No",
    tr_newest: "New",
    tr_promotion: "Promotion",
    tr_hot: "Hot",
    tr_recommend: "Recommended",
    tr_quantity: "Inventory Alert",
    dt_productPut: "Product Warehousing",
    dl_addQuantity: "Add Inventory",
    dp_serial: "Enter the product number",
    db_search: "Search",
    em_serial: "Please enter the correct product number",
    em_putQuantity: "Product storage failed",
    sm_putQuantity: "Product warehousing succeeded"
};
export default product;
